export class Grid {
  readonly K: number;
  readonly M: number;
  private cells: boolean[][][][];

  constructor(K: number, M: number, fill = true) {
    this.K = K;
    this.M = M;
    this.cells = Array.from({ length: K }, () =>
      Array.from({ length: K }, () =>
        Array.from({ length: M }, () => Array.from({ length: M }, () => fill)),
      ),
    );
  }

  get(i: number, j: number, a: number, b: number): boolean {
    return this.cells[i]![j]![a]![b]!;
  }

  eliminate(i: number, j: number, a: number, b: number): boolean {
    if (!this.cells[i]![j]![a]![b]!) return false;
    this.cells[i]![j]![a]![b] = false;
    this.cells[j]![i]![b]![a] = false;
    return true;
  }

  candidates(i: number, j: number, a: number): number[] {
    const out: number[] = [];
    for (let b = 0; b < this.M; b++) if (this.cells[i]![j]![a]![b]!) out.push(b);
    return out;
  }

  clone(): Grid {
    const g = new Grid(this.K, this.M, true);
    for (let i = 0; i < this.K; i++)
      for (let j = 0; j < this.K; j++)
        for (let a = 0; a < this.M; a++)
          for (let b = 0; b < this.M; b++) g.cells[i]![j]![a]![b] = this.cells[i]![j]![a]![b]!;
    return g;
  }

  isSolved(): boolean {
    for (let i = 0; i < this.K; i++)
      for (let j = 0; j < this.K; j++) {
        if (i === j) continue;
        for (let a = 0; a < this.M; a++) if (this.candidates(i, j, a).length !== 1) return false;
      }
    return true;
  }

  /**
   * The solved arrangement, indexed [category][object] against category 0.
   * Nothing ever constrains a category against itself, so category 0's own row
   * is not read out of the grid — it is the anchor, and so the identity.
   */
  extractSolution(): number[][] {
    const sol: number[][] = [];
    for (let c = 0; c < this.K; c++) {
      const row: number[] = [];
      for (let o = 0; o < this.M; o++) {
        row.push(c === 0 ? o : this.candidates(0, c, o)[0]!);
      }
      sol.push(row);
    }
    return sol;
  }
}
